import Translator from '../core/i18n';
import { Dispatch } from 'react';
import * as LearningOutcomeActions from '../store/actions/learningOutcomes';

const T = Translator.create();

export const addLearningOutcomeForActivity = (
    dispatch: Dispatch<any>,
    learningOutcomeId: string,
    activityId: string,
    callback?: () => void
) => {
    dispatch(
        LearningOutcomeActions.addLearningOutcomeForActivity(
            learningOutcomeId,
            activityId,
            "addLearningOutcomeForActivity",
            'get',
            callback
        )
    );
};


export const addLearningOutcomeForQuestion = (
    dispatch: Dispatch<any>,
    learningOutcomeId: string,
    questionId: string,
    callback?: () => void
) => {
    dispatch(
        LearningOutcomeActions.addLearningOutcomeForQuestion(
            learningOutcomeId,
            questionId,
            "addLearningOutcomeForActivity",
            'get',
            callback
        )
    );
};
